import { useTranslation } from 'react-i18next';
import { normalizeKey } from 'utils/localeUtils';
import { DropdownBadgeStyled } from './DropdownBadge.styles';

const DropdownBadge = ({ labelKey }: { labelKey: string }) => {
  const { t } = useTranslation();

  return <DropdownBadgeStyled>{t(normalizeKey(labelKey))}</DropdownBadgeStyled>;
};

export default DropdownBadge;
